import constant from '../../constant'

const initialState = {
  cardContents: [],
  banner: {},
  endCard: {},
  installStay: {}
};

export function recommendVideos (state = initialState, action) {
  switch (action.type) {
    case constant.VIDEO.GET_RECOMMEND_VIDEO:
      return {
        ...state,
        cardContents: action.cardContents,
        banner: action.banner,
        endCard: action.endCard,
        installStay: action.installStay
      }
    default:
      return state
  }

}